import {FC, ReactNode} from "react";
import {Column} from "../atoms/Layout.tsx";
import useRandomId from "../helpers/useRandomId.ts";
import Input from "../atoms/Input.tsx";
import InputLabel from "../atoms/InputLabel.tsx";
import InputHint from "../atoms/InputHint.tsx";

interface Props {
    label: string;
    hint?: string;
    value: string;
    onChange?: (value: string) => void;
    error?: string;
    type?: "text" | "password" | "email" | "tel";
    disabled?: boolean;
    placeholder?: string;
    leftContent?: ReactNode;
    rightContent?: ReactNode;
}


const InputGroup: FC<Props> = ({label, hint, value, onChange, error, type, disabled, placeholder, leftContent, rightContent}) => {
    const elementId = useRandomId();

    return <Column gap="8">
        <InputLabel for={elementId}>{label}</InputLabel>
        <Input
            name={elementId}
            value={value}
            onChange={onChange}
            type={type}
            disabled={disabled}
            placeholder={placeholder}
            leftContent={leftContent}
            rightContent={rightContent}
            error={!!error}
        />
        { !error && hint && <InputHint>{hint}</InputHint> }
        { error && <InputHint error>{error}</InputHint> }
    </Column>
}

export default InputGroup;